import React from "react";
import { Button, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { getHelpUrl, openHelpUrl } from "@core/help-docs";
import "./form-help-button.css";

const DEFAULT_TITLE = "Справка";

const FormHelpButton = ({
  topic,
  pathname,
  variant = "ant",
  className,
  title = DEFAULT_TITLE,
  icon
}) => {
  const location = useLocation();
  const url = getHelpUrl(pathname ?? location.pathname, topic);
  if (!url) return null;

  const open = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    openHelpUrl(url);
  };

  const mark = icon || <QuestionCircleOutlined />;

  if (variant === "native") {
    return (
      <Tooltip title={title}>
        <button type="button" className={className} onClick={open} aria-label={title}>
          {mark}
        </button>
      </Tooltip>
    );
  }

  if (variant === "hub") {
    return (
      <Button
        className={["form-help-button", "form-help-button--hub", className].filter(Boolean).join(" ")}
        icon={mark}
        onClick={open}
        aria-label={title}
      >
        Справка
      </Button>
    );
  }

  return (
    <Tooltip title={title}>
      <Button
        className={["form-help-button", className].filter(Boolean).join(" ")}
        icon={mark}
        onClick={open}
        aria-label={title}
      />
    </Tooltip>
  );
};

export default FormHelpButton;
